import React, { useState, useCallback, useRef } from "react";
import "./css/CareersPage.css";
import FooterPagesBackground from "../assets/FooterPagesBackground.webp";
import liggandebakrund from "../assets/liggandebakgrund.svg";
import ToHomepageBtn from "../components/Shared/ToHomepageBtn";
import DOMPurify from 'dompurify';
import { supabase } from "../supabaseClient";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import FooterInsideSmallerPages from "./FooterInsideSmallerPages";

const MAX_FILE_SIZE = 2 * 1024 * 1024;

function CareersPage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    file: null,
    personligtBrev: null
  });
  const fileRef = useRef(null);
  const personligtBrevRef = useRef(null);
  const checkinboxRef = useRef(null)

  //You wrap the user input string with DOMPurify to avoid xss attack
  const handleInputChange = useCallback((e) => {
    const { name, value, type, checked, files } = e.target;
    let wrapAgainstXxs = value;
    if (type === 'text' || type === "email") {
      wrapAgainstXxs = DOMPurify.sanitize(value)
    }
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked :
        type === 'file' ? files[0] :
          wrapAgainstXxs
    }));
  }, []);

  //checking the size of the PDF
  const validateForm = useCallback(() => {
    const { file, personligtBrev } = formData;
    if (file.size > MAX_FILE_SIZE || personligtBrev > MAX_FILE_SIZE) {
      toast.info("Varje pdf måste vara mindre än 2MB", {
        position: "top-right",
        autoClose: 3000,
      })
    }
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    validateForm();

    try {
      const uploadData = new FormData();
      uploadData.append("firstName", formData.firstName);
      uploadData.append("lastName", formData.lastName);
      uploadData.append("email", formData.email);
      uploadData.append("file", formData.file);
      if (formData.personligtBrev) {
        uploadData.append("personligtBrev", formData.personligtBrev);
      }

      //database insertion
      const { data: emailData, error: emailError } = await supabase
        .from("applicants")
        .insert([
          {
            first_name: formData.firstName,
            last_name: formData.lastName,
            email: formData.email,
          },
        ])
        .select();

      if (emailError) {
        console.error("Error inserting email:", emailError);
        alert("Error creating email: " + emailError.message);
        return;
      }

      //storage insertion
      const filePathForCv = `cv_${emailData.id}`;
      const filePathForCoverLetter = `personligt_brev_${emailData.id}`
      const fileForCv = uploadData.get("file");
      const fileForCoverLetter = uploadData.get("personligtBrev")
      const listToPush = [
        { path: filePathForCv, file: fileForCv },
      ]
      if (fileForCoverLetter) {
        listToPush.push({
          path: filePathForCoverLetter, file: fileForCoverLetter
        })
      }
      const promises = listToPush.map(({ path, file }) =>
        supabase.storage.from("applicants").upload(path, file))
      const pushIt = await Promise.all(promises)

      //cleaning up the form
      setFormData({firstName:'',lastName:'',email:'',file:null,personligtBrev:null});
      if (fileRef.current) fileRef.current.value = ""
      if (personligtBrevRef.current) personligtBrevRef.current.value = ""
      if (checkinboxRef.current) checkinboxRef.current.value = ""

      toast.success("Vi har mottagandet ditt Cv. Tack för din ansökan.", {
        position: "top-right",
        autoClose: 3000,
      })
    } catch (err) {
      toast.error("Något gick fel! Försök igen senare.", {
        position: "top-right",
        autoClose: 3000,
      })
      console.log(err)
    }
  };

  return (
    <div className="workwithus-container">
      <ToastContainer />
      <div
        className="workwithus-background-image"
        style={{ backgroundImage: `url(${liggandebakrund})` }}
      ></div>
      <ToHomepageBtn />
      <div className="workwithus-content-wrapper">
        <div className="workwithus-image-container">
          <img 
            src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?fm=jpg&q=80&w=1000" 
            alt="Jobba hos oss" 
            className="workwithus-image"
          />
        </div>
        <div className="spontanansökan">
          <h2>Spontanansökan</h2>
          <form onSubmit={handleSubmit} className="workwithus-form">
            <input
              type="text"
              name="firstName"
              placeholder="Förnamn"
              value={formData.firstName}
              onChange={handleInputChange}
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Efternamn"
              value={formData.lastName}
              onChange={handleInputChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="E-postadress"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
            <br></br>
            <div className="workwithus-clickbox-div">
              <input type="file" name="file" placeholder="CV" id="workwithus-cv" accept=".pdf" onChange={handleInputChange} ref={fileRef} required>
              </input>
              <label>
                CV
              </label>
            </div>
            <div className="workwithus-clickbox-div">
              <input type="file" name="personligtBrev" placeholder="CV" id="workwithus-cv" accept=".pdf" onChange={handleInputChange} ref={personligtBrevRef}>
              </input>
              <label>
                Personligt brev
              </label>
            </div>
            <br></br>
            <div className="workwithus-clickbox-div">
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  name="acceptTerms"
                  checked={formData.acceptTerms}
                  onChange={handleInputChange}
                  ref={checkinboxRef}
                  required
                />
                <label htmlFor="accept-terms">Tillåter lagring av uppgifter</label>
              </div>
              <a href="google.com" className="linkk">
                Läs villkoren inom GDPR
              </a>
            </div>
            <button type="submit">Skicka in!</button>
          </form>
        </div>
      </div>
      <FooterInsideSmallerPages />
    </div>
  );
}

export default CareersPage;